import React from 'react'
import Header from '../component/Header'
import ExploreResultLocations from '../component/ExploreResultLocations'
import SeeHowCanHelp from '../component/SeeHowCanHelp'
import Footer from '../component/Footer' 
import SeeCanAfford from '../component/SeeCanAfford'
import CalculateYourBuyAbilityComp from '../component/CalculateYourBuyAbilityComp'
function CalculateYourBuyAbility() {
  return (
    <>
      <div className='main calculate-your-buy-ability-page'>
        <Header/>
        <CalculateYourBuyAbilityComp />
        <SeeHowCanHelp />
        <SeeCanAfford />
        <ExploreResultLocations />
        <Footer />
      </div>
    </>
  )
}
export default CalculateYourBuyAbility


